import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=39ae33d0&scoped=true&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae33d0",
  null
  
)

export default component.exports